/**
 * BPP Backend API (Version: 1.0.0.0)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum CustomerPersonPermission {
    StellaAccess = 'StellaAccess',
    StellaCanEditRelations = 'StellaCanEditRelations',
    StellaChat = 'StellaChat',
    StellaCanReadNewsfeedEntry = 'StellaCanReadNewsfeedEntry',
    StellaCanReadArchivedContracts = 'StellaCanReadArchivedContracts',
    CanReadSachversicherungContracts = 'CanReadSachversicherungContracts',
    CanAddSachversicherungClaims = 'CanAddSachversicherungClaims',
    CanReadHaftpflichtContracts = 'CanReadHaftpflichtContracts',
    CanAddHaftpflichtClaims = 'CanAddHaftpflichtClaims',
    CanReadRechtsschutzContracts = 'CanReadRechtsschutzContracts',
    CanAddRechtsschutzClaims = 'CanAddRechtsschutzClaims',
    CanReadFinancialLinesContracts = 'CanReadFinancialLinesContracts',
    CanAddFinancialLinesClaims = 'CanAddFinancialLinesClaims',
    CanReadTransportContracts = 'CanReadTransportContracts',
    CanAddTransportClaims = 'CanAddTransportClaims',
    CanReadTechnikContracts = 'CanReadTechnikContracts',
    CanAddTechnikClaims = 'CanAddTechnikClaims',
    CanReadKfzContracts = 'CanReadKfzContracts',
    CanAddKfzClaims = 'CanAddKfzClaims',
    CanReadPersonContracts = 'CanReadPersonContracts',
    CanAddPersonClaims = 'CanAddPersonClaims',
    CanReadSonstigeContracts = 'CanReadSonstigeContracts',
    CanAddSonstigeClaims = 'CanAddSonstigeClaims'
  }

    export const CustomerPersonPermissionTranslocoMap: Record<CustomerPersonPermission, string> = {
    [CustomerPersonPermission.StellaAccess]: 'customerPersonPermission.stellaAccess',
    [CustomerPersonPermission.StellaCanEditRelations]: 'customerPersonPermission.stellaCanEditRelations',
    [CustomerPersonPermission.StellaChat]: 'customerPersonPermission.stellaChat',
    [CustomerPersonPermission.StellaCanReadNewsfeedEntry]: 'customerPersonPermission.stellaCanReadNewsfeedEntry',
    [CustomerPersonPermission.StellaCanReadArchivedContracts]: 'customerPersonPermission.stellaCanReadArchivedContracts',
    [CustomerPersonPermission.CanReadSachversicherungContracts]: 'customerPersonPermission.canReadSachversicherungContracts',
    [CustomerPersonPermission.CanAddSachversicherungClaims]: 'customerPersonPermission.canAddSachversicherungClaims',
    [CustomerPersonPermission.CanReadHaftpflichtContracts]: 'customerPersonPermission.canReadHaftpflichtContracts',
    [CustomerPersonPermission.CanAddHaftpflichtClaims]: 'customerPersonPermission.canAddHaftpflichtClaims',
    [CustomerPersonPermission.CanReadRechtsschutzContracts]: 'customerPersonPermission.canReadRechtsschutzContracts',
    [CustomerPersonPermission.CanAddRechtsschutzClaims]: 'customerPersonPermission.canAddRechtsschutzClaims',
    [CustomerPersonPermission.CanReadFinancialLinesContracts]: 'customerPersonPermission.canReadFinancialLinesContracts',
    [CustomerPersonPermission.CanAddFinancialLinesClaims]: 'customerPersonPermission.canAddFinancialLinesClaims',
    [CustomerPersonPermission.CanReadTransportContracts]: 'customerPersonPermission.canReadTransportContracts',
    [CustomerPersonPermission.CanAddTransportClaims]: 'customerPersonPermission.canAddTransportClaims',
    [CustomerPersonPermission.CanReadTechnikContracts]: 'customerPersonPermission.canReadTechnikContracts',
    [CustomerPersonPermission.CanAddTechnikClaims]: 'customerPersonPermission.canAddTechnikClaims',
    [CustomerPersonPermission.CanReadKfzContracts]: 'customerPersonPermission.canReadKfzContracts',
    [CustomerPersonPermission.CanAddKfzClaims]: 'customerPersonPermission.canAddKfzClaims',
    [CustomerPersonPermission.CanReadPersonContracts]: 'customerPersonPermission.canReadPersonContracts',
    [CustomerPersonPermission.CanAddPersonClaims]: 'customerPersonPermission.canAddPersonClaims',
    [CustomerPersonPermission.CanReadSonstigeContracts]: 'customerPersonPermission.canReadSonstigeContracts',
    [CustomerPersonPermission.CanAddSonstigeClaims]: 'customerPersonPermission.canAddSonstigeClaims',
    };

    export const CustomerPersonPermissionOptions = [
  { value: CustomerPersonPermission.StellaAccess, labelKey: 'customerPersonPermission.stellaAccess' },
  { value: CustomerPersonPermission.StellaCanEditRelations, labelKey: 'customerPersonPermission.stellaCanEditRelations' },
  { value: CustomerPersonPermission.StellaChat, labelKey: 'customerPersonPermission.stellaChat' },
  { value: CustomerPersonPermission.StellaCanReadNewsfeedEntry, labelKey: 'customerPersonPermission.stellaCanReadNewsfeedEntry' },
  { value: CustomerPersonPermission.StellaCanReadArchivedContracts, labelKey: 'customerPersonPermission.stellaCanReadArchivedContracts' },
  { value: CustomerPersonPermission.CanReadSachversicherungContracts, labelKey: 'customerPersonPermission.canReadSachversicherungContracts' },
  { value: CustomerPersonPermission.CanAddSachversicherungClaims, labelKey: 'customerPersonPermission.canAddSachversicherungClaims' },
  { value: CustomerPersonPermission.CanReadHaftpflichtContracts, labelKey: 'customerPersonPermission.canReadHaftpflichtContracts' },
  { value: CustomerPersonPermission.CanAddHaftpflichtClaims, labelKey: 'customerPersonPermission.canAddHaftpflichtClaims' },
  { value: CustomerPersonPermission.CanReadRechtsschutzContracts, labelKey: 'customerPersonPermission.canReadRechtsschutzContracts' },
  { value: CustomerPersonPermission.CanAddRechtsschutzClaims, labelKey: 'customerPersonPermission.canAddRechtsschutzClaims' },
  { value: CustomerPersonPermission.CanReadFinancialLinesContracts, labelKey: 'customerPersonPermission.canReadFinancialLinesContracts' },
  { value: CustomerPersonPermission.CanAddFinancialLinesClaims, labelKey: 'customerPersonPermission.canAddFinancialLinesClaims' },
  { value: CustomerPersonPermission.CanReadTransportContracts, labelKey: 'customerPersonPermission.canReadTransportContracts' },
  { value: CustomerPersonPermission.CanAddTransportClaims, labelKey: 'customerPersonPermission.canAddTransportClaims' },
  { value: CustomerPersonPermission.CanReadTechnikContracts, labelKey: 'customerPersonPermission.canReadTechnikContracts' },
  { value: CustomerPersonPermission.CanAddTechnikClaims, labelKey: 'customerPersonPermission.canAddTechnikClaims' },
  { value: CustomerPersonPermission.CanReadKfzContracts, labelKey: 'customerPersonPermission.canReadKfzContracts' },
  { value: CustomerPersonPermission.CanAddKfzClaims, labelKey: 'customerPersonPermission.canAddKfzClaims' },
  { value: CustomerPersonPermission.CanReadPersonContracts, labelKey: 'customerPersonPermission.canReadPersonContracts' },
  { value: CustomerPersonPermission.CanAddPersonClaims, labelKey: 'customerPersonPermission.canAddPersonClaims' },
  { value: CustomerPersonPermission.CanReadSonstigeContracts, labelKey: 'customerPersonPermission.canReadSonstigeContracts' },
  { value: CustomerPersonPermission.CanAddSonstigeClaims, labelKey: 'customerPersonPermission.canAddSonstigeClaims' },
    ];

